



















































































































































































































import toastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import i18n from "@/libs/i18n";
import { useWebhooksStore } from "@/store/useWebhooksStore";
import type { Webhook } from "@/types/webhook.types";
import ApiStatus from "@/views/modules/settings/developers/components/apiStatus.vue";
import useWebhooks from "@/views/modules/settings/developers/useWebhooks";
import { WebhookEvents } from "@saysimple-platform/dtos/dist/types"; //@ts-ignore
import { required, url } from "@validations";
import { defineComponent, ref, Ref } from "@vue/composition-api";
import {
    BBadge,
    BButton,
    BCol,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BModal,
    BRow,
    BSpinner,
    BTable,
    VBTooltip,
} from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { useToast } from "vue-toastification/composition";

extend("jsonParse", {
    validate: (value) => {
        try {
            JSON.parse(value);
            return true;
        } catch {
            return false;
        }
    },
    message: i18n.t("settings.developers.webhooks.headers-error") as string,
});

export default defineComponent({
    components: {
        ValidationProvider,
        ValidationObserver,
        ApiStatus,
        BBadge,
        BButton,
        BCol,
        BForm,
        BFormCheckbox,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BFormTextarea,
        BModal,
        BRow,
        BSpinner,
        BTable,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup(_, { root }) {
        const toast = useToast();
        const { tableColumns, sortBy, isSortDirDesc, read } = useWebhooks();
        const { webhooks, isLoadingWebhooks, isLoadingWebhook } = storeToRefs(useWebhooksStore());
        const showModal = ref(false);
        // const { copy, copied, isSupported } = useClipboard(); // @todo

        read();

        const events: Array<keyof WebhookEvents> = [
            "chat::archived",
            "chat::assigned",
            "chat::created",
            "chat::unarchived",
            "chat::unassigned",
            "entry::declined",
            "entry::delivered",
            "entry::read",
            "entry::received",
            "entry::sent",
        ];
        const versions = [
            { value: 3, text: 3 },
            { value: 2, text: 2, disabled: true },
            {
                value: 1,
                text: 1,
                disabled: true,
            },
        ];

        const webhook: Ref<Webhook> = ref({
            id: undefined,
            url: undefined,
            event: events[0],
            enabled: 1,
            headers: undefined,
            version: versions[0].value,
        });

        //----------------------------------------------------------

        const submit = () => {
            if (webhook.value.id) {
                updateWebhook(webhook.value.id, webhook.value).then(() => (showModal.value = false));
            } else {
                createWebhook().then(() => (showModal.value = false));
            }
        };

        const reset = () => {
            webhook.value = {
                id: undefined,
                url: undefined,
                event: events[0],
                enabled: 1,
                headers: undefined,
                version: versions[0].value,
            };
        };

        //----------------------------------------------------------

        const showWebhookModal = (webhookId?: number) => {
            if (webhookId) {
                const { getWebhookById } = useWebhooksStore();
                Object.assign(webhook.value, getWebhookById(webhookId)); // Object assign to create a shallow copy, because we get one from the webhooks state and do not like to change the reference from the list directly.
            }

            showModal.value = true;
        };

        //----------------------------------------------------------

        const createWebhook = () => {
            const { createWebhook } = useWebhooksStore();

            return createWebhook(webhook.value)
                .then((res) => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("settings.developers.webhooks.webhooks"),
                            text: i18n.t("settings.developers.webhooks.webhook-created-success"),
                            icon: "check",
                            variant: "success",
                        },
                    });

                    return res;
                })
                .catch((e) => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("settings.developers.webhooks.webhooks"),
                            text: i18n.t("settings.developers.webhooks.webhook-created-error"),
                            icon: "times",
                            variant: "error",
                        },
                    });

                    throw e;
                });
        };

        //----------------------------------------------------------

        const updateWebhook = (webhookId: number, webhook: Partial<Webhook>) => {
            const { updateWebhook } = useWebhooksStore();

            return updateWebhook(webhookId, webhook)
                .then((res) => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("settings.developers.webhooks.webhooks"),
                            text: i18n.t("settings.developers.webhooks.webhook-updated-success"),
                            icon: "check",
                            variant: "success",
                        },
                    });

                    return res;
                })
                .catch((e) => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("settings.developers.webhooks.webhooks"),
                            text: i18n.t("settings.developers.webhooks.webhook-updated-error"),
                            icon: "times",
                            variant: "error",
                        },
                    });

                    throw e;
                });
        };

        //----------------------------------------------------------

        const deleteWebhook = (webhookId: number) => {
            root.$bvModal
                .msgBoxConfirm(i18n.t("confirm.Are you sure?"), {
                    title: i18n.t("confirm.Are you sure?"),
                    cancelTitle: i18n.t("confirm.Cancel"),
                    cancelVariant: "light",
                    okTitle: i18n.t("confirm.Yes, delete"),
                    hideHeaderClose: false,
                    headerCloseVariant: "light",
                    centered: true,
                    bodyClass: "mx-auto",
                    headerClass: "text-center",
                })
                .then((result) => {
                    if (result) {
                        const { deleteWebhook } = useWebhooksStore();
                        return deleteWebhook(webhookId)
                            .then((res) => {
                                toast({
                                    component: toastificationContent,
                                    props: {
                                        title: i18n.t("settings.developers.webhooks.webhooks"),
                                        text: i18n.t("settings.developers.webhooks.webhook-deleted-success"),
                                        icon: "check",
                                        variant: "success",
                                    },
                                });

                                return res;
                            })
                            .catch(() => {
                                toast({
                                    component: toastificationContent,
                                    props: {
                                        title: i18n.t("settings.developers.webhooks.webhooks"),
                                        text: i18n.t("settings.developers.webhooks.webhook-deleted-error"),
                                        icon: "times",
                                        variant: "error",
                                    },
                                });
                            });
                    }
                });
        };

        const searchQuery = ref("");
        const validator = ref<InstanceType<typeof ValidationObserver>>();
        return {
            deleteWebhook,
            events,
            isLoadingWebhook,
            isLoadingWebhooks,
            isSortDirDesc,
            required,
            reset,
            searchQuery,
            showModal,
            showWebhookModal,
            sortBy,
            submit,
            tableColumns,
            updateWebhook,
            url,
            validator,
            versions,
            webhook,
            webhooks,
        };
    },
});
